// extracted by mini-css-extract-plugin
export default {"arrow-icon":"table_arrow-icon__L19Kr","table":"table_table__qgMqm"};